import { toast } from "sonner";
import { Copy, DollarSign, MapPin, ExternalLink } from "lucide-react";

export default function CashApp() {
  const copy = async (text, label) => {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text);
      } else {
        const ta = document.createElement("textarea");
        ta.value = text;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
      }
      toast.success(`${label} copied to clipboard!`);
    } catch (e) {
      toast.error(`Couldn't copy ${label}. Please copy manually.`);
    }
  };

  const address = "Chase — Class of 2030\nMailbox # [Coming Soon]\nCurry College\n1071 Blue Hill Avenue\nMilton, MA 02186";

  return (
    <section id="donate" className="py-24 md:py-32 max-w-7xl mx-auto px-4 sm:px-6">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div className="relative rounded-3xl bg-zinc-900 border-2 border-[#00d632]/40 p-8 md:p-12 overflow-hidden shadow-[0_0_40px_rgba(0,214,50,0.15)]">
          <div className="absolute -top-20 -right-20 w-64 h-64 rounded-full bg-[#00d632]/10 blur-3xl" />
          <p className="font-sub text-xs tracking-[0.2em] uppercase font-bold text-[#00d632] mb-3">Cash Blessings</p>
          <h2 className="font-display text-4xl sm:text-5xl tracking-tight uppercase mb-4">
            Send A <span className="text-[#00d632]">Blessing</span>
          </h2>
          <p className="font-sub text-zinc-400 mb-8 max-w-md">
            Every dollar helps with books, food runs, laundry money, and game-day fuel.
            Send directly through Cash App.
          </p>
          <div className="flex items-center gap-4 bg-zinc-950 border border-[#00d632]/30 rounded-2xl p-5 mb-6">
            <div className="w-12 h-12 rounded-xl bg-[#00d632] flex items-center justify-center flex-shrink-0">
              <DollarSign className="w-6 h-6 text-black" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs text-zinc-500 font-sub uppercase tracking-wider">Cash App Tag</p>
              <p data-testid="cashapp-tag" className="font-sub font-bold text-xl text-white truncate">$Vanilla3808</p>
            </div>
            <button
              data-testid="cashapp-copy-btn"
              onClick={() => copy("$Vanilla3808", "Cash App tag")}
              className="p-3 rounded-xl border border-white/10 hover:border-[#00d632] text-zinc-400 hover:text-[#00d632] transition-colors duration-200 active:scale-95"
              aria-label="Copy Cash App tag"
            >
              <Copy className="w-5 h-5" />
            </button>
          </div>
          <a
            href="https://cash.app/$Vanilla3808"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cashapp-donate-button"
            className="inline-flex items-center gap-2 font-sub font-bold bg-[#00d632] hover:bg-[#00c02d] text-black px-8 py-4 rounded-full transition-colors duration-200 active:scale-95"
          >
            Open Cash App <ExternalLink className="w-4 h-4" />
          </a>
        </div>

        <div className="rounded-3xl bg-zinc-900 border border-white/5 p-8 md:p-12 flex flex-col">
          <p className="font-sub text-xs tracking-[0.2em] uppercase font-bold text-purple-400 mb-3">Care Packages</p>
          <h2 className="font-display text-4xl sm:text-5xl tracking-tight uppercase mb-4">
            Mail It <span className="text-purple-400">To Chase</span>
          </h2>
          <p className="font-sub text-zinc-400 mb-8 max-w-md">
            Ship gifts, care packages, and snail-mail postcards directly to campus.
            Amazon and most stores can deliver straight to his mailbox.
          </p>
          <div className="flex items-start gap-4 bg-zinc-950 border border-purple-500/30 rounded-2xl p-5 mb-6">
            <div className="w-12 h-12 rounded-xl bg-purple-600 flex items-center justify-center flex-shrink-0">
              <MapPin className="w-6 h-6 text-white" />
            </div>
            <div className="flex-1">
              <p className="text-xs text-zinc-500 font-sub uppercase tracking-wider mb-1">Mailing Address</p>
              <p data-testid="mailing-address" className="font-sub text-white whitespace-pre-line leading-relaxed">{address}</p>
              <p className="text-xs text-zinc-500 mt-2 italic">* Mailbox number will be added after move-in on Aug 11 — check back!</p>
            </div>
          </div>
          <button
            data-testid="address-copy-btn"
            onClick={() => copy(address.replace(/\n/g, ", "), "Address")}
            className="inline-flex items-center justify-center gap-2 font-sub font-semibold border border-purple-500/50 hover:bg-purple-600 text-white px-8 py-4 rounded-full transition-colors duration-200 active:scale-95 mt-auto"
          >
            <Copy className="w-4 h-4" /> Copy Address
          </button>
        </div>
      </div>
    </section>
  );
}
